import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  applyCompanyTheme(colore1: string, colore2: string, logo?: string) {
    const r = (v: string) => v?.toLowerCase?.() || v;

    // Mappa "rosso/bianco" a valori reali: qui puoi creare una mappa più ricca
    const map: Record<string, string> = {
      rosso: '#e53935',
      bianco: '#ffffff',
      nero: '#000000',
      blu: '#1e88e5',
      giallo: '#fbc02d',
      verde: '#43a047',
      grigio: '#9e9e9e',
    };

    const c1 = map[r(colore1)] || colore1; // se è già hex lo usa
    const c2 = map[r(colore2)] || colore2;

    document.documentElement.style.setProperty('--brand-primary', c1);
    document.documentElement.style.setProperty('--brand-secondary', c2);

    if (logo) {
      // opzionale: salva in <html> un data-attr per recuperare logo ovunque
      document.documentElement.setAttribute('data-company-logo', logo);
    }
  }
}
